import { ajax } from '@/api/ajax';

export interface BookmapTopicRefDetailReq {
  /**
   * 手册编码
   */
  bookmapCode?: string;
  /**
   * 手册版本
   */
  bookmapVersion: string;
  /**
   * 功能码
   */
  functionCode?: string;
  /**
   * 车型编码
   */
  modelCode?: string;
  /**
   * 地区
   */
  region?: string;
  /**
   * 文章编码
   */
  topicCode?: string;
}

export interface BookmapTopicExistsResp {
  /**
   * 文章是否存在
   */
  exists?: boolean;
  topicName?: string;
  topicCode?: string;
  topicVersion?: string;
}

/**
 * @operationId isTopicExistsUsingPOST
 * @tags 手册
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-tis-cn-boot/doc.html#/%E6%89%8B%E5%86%8C/%E6%89%8B%E5%86%8C/isTopicExistsUsingPOST
 */
export function isTopicExistsUsingPost(data: BookmapTopicRefDetailReq) {
  return ajax<BookmapTopicExistsResp>({
    url: '/api/tis/web/bookmap/topic/ref/exists',
    method: 'post',
    data: data
  });
}
